module.exports = "<div data-container=\"filters\">\n</div>\n<div data-container=\"list\">\n</div>\n"